import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '~/api-client';
import { BoloAutocompleteView, BoloResource, EventAutocompleteView } from '@mark43/cad-api';
import { AssociateEntityFormDisplayType } from '../../associate-event/components/associate-entity-form';

export function useAssociateBolo(
    boloId: number,
    onSuccess: (...args: unknown[]) => unknown,
    entityType: 'BOLO' | 'EVENT'
) {
    const apiClient = useApiClient();

    return useMutation(
        ['associate-bolo', boloId],
        (form: AssociateEntityFormDisplayType) => {
            const associateBolo = entityType === 'BOLO';
            return apiClient.request<BoloResource.AssociateBolo>({
                method: 'POST',
                url: 'bolo/associate',
                data: {
                    boloId: form.entityId,
                    associatedEventIds: !associateBolo
                        ? form.associatedEntities.map(
                              (field) => (field as EventAutocompleteView).agencyEventId
                          )
                        : [],
                    associatedBoloIds: associateBolo
                        ? form.associatedEntities.map(
                              (field) => (field as BoloAutocompleteView).boloId
                          )
                        : [],
                    reason: form.reason ?? '',
                },
            });
        },
        {
            onSuccess() {
                onSuccess();
            },
        }
    );
}
